import React, {useState} from 'react';
import {timeSince} from "../../../utilities/utils";
import PostDetailsCommentForm from "./PostDetailsCommentForm";
import {database} from "../../../config/firebase";
import {toastr} from "react-redux-toastr";
import {useDispatch} from "react-redux";
import Link from "next/link";
import has from 'lodash/has';

import 'semantic-ui-css/components/comment.min.css'
import 'semantic-ui-css/components/icon.min.css'
import {ref, runTransaction} from "firebase/database";
import {openModal} from "../../../features/modals/modalActions";
import {Comment, Icon} from 'semantic-ui-react';
import {useUser} from "../../../context/userContext";


const PostDetailsComments = ({postId, comments, postAuthorId}) => {

    const [showReplyForm, setShowReplyForm] = useState(false);
    const [selectedCommentId, setSelectedCommentId] = useState(null);
    const {userId} = useUser()
    const dispatch = useDispatch()

    const handleOpenReplyForm = id => () => {
        setShowReplyForm(!showReplyForm)
        setSelectedCommentId(id)
    };

    const handleCloseReplyForm = () => {
        setShowReplyForm(false)
        setSelectedCommentId(null)
    };

    const toggleLikeButton = async (commentId) => {
        if (Boolean(userId)) {
            let commentPath = '/comments/'.concat(postId, '/', commentId);
            const commentFirebaseRef = ref(database, commentPath);
            await runTransaction(commentFirebaseRef, function (comment) {
                if (comment) {
                    if (comment.lk && comment.lk[userId]) {
                        comment.dVC--;
                        comment.lk[userId] = null;
                    } else {
                        if (comment.dlk && comment.dlk[userId]) {
                            comment.dVC++;
                            comment.dlk[userId] = null;
                        } else {
                            comment.dVC = (comment.dVC || 0) + 1;
                            if (!comment.lk) {
                                comment.lk = {};
                            }
                            comment.lk[userId] = true;
                        }
                    }
                }
                return comment;
            });
        } else {
            dispatch(openModal('UnauthModal'))
        }
    };

    const toggleDislikeButton = async (commentId) => {
        // Update Groups

        if (Boolean(userId)) {
            let commentPath = '/comments/'.concat(postId, '/', commentId);
            const commentFirebaseRef = ref(database, commentPath);

            await runTransaction(commentFirebaseRef, function (comment) {
                if (comment) {
                    if (comment.dlk && comment.dlk[userId]) {
                        comment.dVC++;
                        comment.dlk[userId] = null;
                    } else {
                        if (comment.lk && comment.lk[userId]) {
                            comment.dVC--;
                            comment.lk[userId] = null;
                        } else {
                            comment.dVC = (comment.dVC || 0) - 1;
                            if (!comment.dlk) {
                                comment.dlk = {};
                            }
                            comment.dlk[userId] = true;
                        }
                    }
                }
                return comment;
            });
        } else {
            openModal('UnauthModal')
        }
    };

    const reportComment = (commentId) => {
        // Update Groups
        if (Boolean(userId)) {
            let commentPath = '/comments/'.concat(postId, '/', commentId);
            const commentFirebaseRef = ref(database, commentPath);
            runTransaction(commentFirebaseRef, function (comment) {
                if (comment) {
                    comment.rc++;
                }
                return comment;
            }).then(() => {
                toastr.success('Success', 'Comment Reported!')
            });
        } else {
            openModal('UnauthModal')
        }
    };


    return (
        <Comment.Group className={'pb-0'}>
            {comments &&
            comments.map(comment =>
                <Comment key={comment.id}>
                    <Comment.Avatar
                        src={"https://eu.ui-avatars.com/api/?name=".concat(comment.a, '&size=35')}
                    />
                    <Comment.Content>
                        <Link href="/u/[id]" as={`/u/${comment.aId}`}>
                            <Comment.Author>
                                {comment.a}
                            </Comment.Author>
                        </Link>
                        <Comment.Metadata className={'ml-0'}>
                            {comment.isOP && '(OP📣)  '}
                            {comment.isFTC && '(FTC🥇️️)  '}
                            {timeSince(comment.ts)}
                        </Comment.Metadata>
                        <Comment.Text>{comment.t}</Comment.Text>
                        <Comment.Actions>
                            <Comment.Action
                                onClick={handleOpenReplyForm(comment.id)}
                            >
                                Reply
                            </Comment.Action>
                            <Comment.Action
                                onClick={() => toggleLikeButton(comment.id)}
                            >
                                <Icon name='thumbs up'
                                      color={has(comment.lk, userId) ? "green" : "grey"}/>{comment.dVC}
                            </Comment.Action>
                            <Comment.Action
                                onClick={() => toggleDislikeButton(comment.id)}
                            >
                                <Icon name='thumbs down'
                                      color={has(comment.dlk, userId) ? "red" : "grey"}/>
                            </Comment.Action>
                            <Comment.Action
                                onClick={() => reportComment(comment.id)}
                            >
                                Report
                            </Comment.Action>
                            {showReplyForm && selectedCommentId === comment.id && <PostDetailsCommentForm
                                postAuthorId={postAuthorId}
                                postId={postId}
                                form={`reply_${comment.id}`}
                                closeForm={handleCloseReplyForm}
                                parentId={comment.id}
                            />}
                        </Comment.Actions>
                    </Comment.Content>
                    {comment.replies && <PostDetailsComments postId={postId} postAuthorId={postAuthorId}
                                                             comments={comment.replies}/>
                    }
                </Comment>)}
        </Comment.Group>
    )
}

export default PostDetailsComments;